import { render } from "./OrderTracking.vue?vue&type=template&id=966aeb5a"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import "./OrderTracking.vue?vue&type=style&index=0&id=966aeb5a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__